<template>
  <div class="match-detail">
    <header class="page-header">
      <h2 class="page-header__title">{{ pageTitle }}</h2>
    </header>

    <el-form
      ref="form"
      :model="form"
      :rules="formRules"
      :disabled="formDisabled"
      label-width="120px"
      class="detail-form"
    >
      <!-- 基础信息 -->
      <div class="section-card">
        <div class="section-title">基础信息</div>
        <div class="section-body">
          <el-form-item prop="matchType">
            <template slot="label"
              ><span class="req-star">*</span><span>赛事类型</span></template
            >
            <el-select
              v-model="form.matchType"
              class="same-width-input"
              placeholder="请选择赛事类型"
              :disabled="formDisabled"
            >
              <el-option
                v-for="opt in matchTypeOptions"
                :key="opt.value"
                :label="opt.label"
                :value="opt.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="赛事标题" prop="title">
            <el-input
              v-model="form.title"
              placeholder="请输入赛事标题，不超过30个字"
              :maxlength="30"
              show-word-limit
              class="same-width-input"
              :disabled="formDisabled"
            ></el-input>
          </el-form-item>
          <el-form-item prop="signTime">
            <template slot="label"
              ><span class="req-star">*</span><span>报名时间</span></template
            >
            <el-date-picker
              v-model="form.signTime"
              :disabled="formDisabled"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              value-format="yyyy-MM-dd HH:mm:ss"
              :picker-options="signTimePickerOptions"
              @change="onSignTimePickerChange"
            ></el-date-picker>
          </el-form-item>
          <el-form-item prop="endTime">
            <template slot="label"
              ><span class="req-star">*</span><span>比赛时间</span></template
            >
            <el-date-picker
              v-model="form.endTime"
              :disabled="formDisabled"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              value-format="yyyy-MM-dd HH:mm:ss"
              :picker-options="matchTimePickerOptions"
              @change="onMatchTimePickerChange"
            ></el-date-picker>
          </el-form-item>
        </div>
      </div>

      <!-- 比赛规则 -->
      <div class="section-card">
        <div class="section-title">比赛规则</div>
        <div class="section-body">
          <el-form-item prop="finishType">
            <template slot="label"
              ><span class="req-star">*</span><span>比赛要求</span></template
            >
            <el-radio-group v-model="form.finishType" :disabled="formDisabled">
              <el-radio :label="1">需一次性完成</el-radio>
              <el-radio :label="2">可累计完成</el-radio>
            </el-radio-group>
            <div class="form-tip">
              一次性完成：指参赛的组别需通过单次运动完成；可累计完成：指参赛组别可多次运动累计完成
            </div>
          </el-form-item>

          <el-form-item prop="runTypes">
            <template slot="label"
              ><span class="req-star">*</span><span>跑步类型</span></template
            >
            <div class="run-types">
              <el-checkbox-group
                v-model="form.runTypes"
                :disabled="formDisabled"
                @change="onRunTypesChange"
              >
                <el-checkbox :label="1" :disabled="true">户外跑</el-checkbox>
                <el-checkbox :label="2">校园跑</el-checkbox>
              </el-checkbox-group>
            </div>
          </el-form-item>

          <!-- 参赛组别 -->
          <el-form-item prop="groups">
            <template slot="label"
              ><span class="req-star">*</span><span>参赛组别</span></template
            >
            <div class="group-list">
              <div
                v-for="(group, index) in form.groups"
                :key="index"
                class="group-item"
              >
                <el-select
                  v-model="group.type"
                  placeholder="类型"
                  style="width: 100px"
                  :disabled="formDisabled"
                  @change="onGroupTypeChange(group)"
                >
                  <el-option label="公里数" :value="1"></el-option>
                  <el-option label="消耗" :value="2"></el-option>
                </el-select>
                <el-select
                  v-model="group.distanceType"
                  placeholder="公里数类型"
                  style="width: 120px; margin-left: 10px"
                  v-if="group.type === 1"
                  :disabled="formDisabled"
                  @change="onDistanceTypeChange(group)"
                >
                  <el-option label="自定义" :value="0"></el-option>
                  <el-option label="半马" :value="1"></el-option>
                  <el-option label="全马" :value="2"></el-option>
                </el-select>
                <el-input
                  v-model="group.distance"
                  placeholder="请输入公里数"
                  style="width: 120px; margin-left: 10px"
                  v-if="group.type === 1 && group.distanceType === 0"
                  :disabled="formDisabled"
                  @keydown.native="onDistanceKeydown"
                  @paste.native.prevent="(e) => onDistancePaste(e, group)"
                  @input="(val) => onDistanceInput(val, group)"
                  @compositionend.native="
                    (e) => onDistanceCompositionEnd(e, group)
                  "
                  @blur="onDistanceBlur(group)"
                ></el-input>
                <span
                  v-if="group.type === 1 && group.distanceType !== 0"
                  style="width: 120px; margin-left: 10px; display: inline-block"
                  >{{ group.distance }}公里</span
                >
                <el-input
                  v-if="group.type === 2"
                  v-model="group.distance"
                  placeholder="请输入消耗值"
                  style="width: 120px; margin-left: 10px"
                  :disabled="formDisabled"
                  @keydown.native="onCalorieKeydown"
                  @paste.native.prevent="(e) => onCaloriePaste(e, group)"
                  @input="(val) => onCalorieInput(val, group)"
                  @compositionend.native="
                    (e) => onCalorieCompositionEnd(e, group)
                  "
                ></el-input>
                <span
                  v-if="group.type === 2"
                  style="
                    margin-left: 4px;
                    color: #606266;
                    line-height: 40px;
                    flex-shrink: 0;
                  "
                  >千卡</span
                >
                <el-button
                  type="danger"
                  size="small"
                  style="margin-left: 10px"
                  @click="removeGroup(index)"
                  v-if="index > 0 && !formDisabled"
                  >删除</el-button
                >
              </div>
              <template v-if="!formDisabled">
                <el-button
                  type="primary"
                  size="small"
                  icon="el-icon-plus"
                  @click="addGroup"
                  style="margin-top: 8px"
                  :disabled="form.groups.length >= 6"
                  >新增组别</el-button
                >
                <span
                  v-if="form.groups.length >= 6"
                  style="margin-left: 10px; color: #999"
                  >最多添加6组</span
                >
              </template>
            </div>
          </el-form-item>

          <!-- 平均配速要求 -->
          <el-form-item label="平均配速要求" prop="paceType">
            <el-radio-group
              v-model="form.paceType"
              class="pace-radio-group"
              :disabled="formDisabled"
            >
              <el-radio :label="0">不限</el-radio>
              <el-radio :label="1">限制</el-radio>
            </el-radio-group>
            <div class="pace-limit-row" v-if="form.paceType === 1">
              <el-input-number
                v-model="form.paceMin"
                :disabled="formDisabled"
                :min="0"
                :max="59"
                controls-position="right"
                placeholder="分钟"
                style="width: 120px"
              ></el-input-number>
              <span class="pace-sep">分</span>
              <el-input-number
                v-model="form.paceMax"
                :disabled="formDisabled"
                :min="0"
                :max="59"
                controls-position="right"
                placeholder="秒数"
                style="width: 120px"
              ></el-input-number>
              <span class="pace-sep">秒/公里 —</span>
              <el-input-number
                v-model="form.paceMinEnd"
                :disabled="formDisabled"
                :min="0"
                :max="59"
                controls-position="right"
                placeholder="分钟"
                style="width: 120px"
              ></el-input-number>
              <span class="pace-sep">分</span>
              <el-input-number
                v-model="form.paceMaxEnd"
                :disabled="formDisabled"
                :min="0"
                :max="59"
                controls-position="right"
                placeholder="秒数"
                style="width: 120px"
              ></el-input-number>
              <span class="pace-sep">秒/公里</span>
            </div>
          </el-form-item>
        </div>
      </div>

      <div class="section-card" ref="packageSection">
        <div class="section-title">
          <span v-if="mode !== 'view'" class="req-star">*</span>套餐配置
          <template v-if="!formDisabled">
            <el-button
              type="primary"
              size="small"
              icon="el-icon-plus"
              style="margin-left: 12px"
              @click="addPackage"
              :disabled="form.packages.length >= 10"
              >新增套餐</el-button
            >
            <span
              v-if="form.packages.length >= 10"
              style="margin-left: 10px; color: #999"
              >最多添加10个</span
            >
          </template>
        </div>
        <div v-if="packagesError" class="packages-error-tip">
          {{ packagesError }}
        </div>
        <div class="package-list">
          <div
            v-for="(pkg, index) in form.packages"
            :key="pkg.id"
            class="package-item"
          >
            <div class="package-header">
              <el-button
                type="danger"
                size="small"
                @click="removePackage(index)"
                v-if="form.packages.length > 0 && !formDisabled"
                >删除</el-button
              >
            </div>
            <package-config
              :package-data="pkg"
              :package-index="index"
              :readonly="formDisabled"
              :images-editable="imagesEditable"
              @relate-prize="onRelatePrize"
              @preview-image="previewImage"
            ></package-config>
          </div>
        </div>
      </div>

      <!-- 赛事封面 & 详情 -->
      <div class="section-card">
        <div class="section-body section-indent">
          <div class="detail-section">
            <div class="detail-title-row">
              <span class="detail-title"
                ><span class="req-star">*</span>赛事封面图</span
              >
              <span class="detail-title-hint"
                >尺寸建议370*180，最大300KB，优先webp次选png</span
              >
            </div>
            <div class="detail-content">
              <el-form-item
                prop="coverUrl"
                label=""
                label-width="0px"
                class="match-cover-form-item"
              >
                <div class="match-upload-block">
                  <div class="match-dynamic-upload-list">
                    <div class="match-dynamic-upload-bezel match-dynamic-upload-bezel--210">
                      <SUpload
                        v-if="imagesEditable"
                        v-model="form.coverUrl"
                        actionUrl="/adminapi/v1/basicTools/v650/file/upload?uploadImageType=11&fileType=1"
                        :headers="uploadAuthHeaders"
                        accept="image/*"
                        type="drag"
                        :size="300"
                        :show-file-list="false"
                      />
                      <div
                        v-else-if="form.coverUrl"
                        class="match-upload-preview-box match-upload-preview-box--view"
                        @click="previewImage(form.coverUrl)"
                      >
                        <img :src="form.coverUrl" alt="" />
                      </div>
                      <div v-else class="match-upload-empty-view">暂无图片</div>
                    </div>
                  </div>
                </div>
              </el-form-item>
            </div>
          </div>
          <div class="detail-section">
            <div class="detail-title-row">
              <span class="detail-title">赛事详情</span>
            </div>
            <div class="detail-content">
              <div class="detail-stack">
                <div class="detail-upload-field">
                  <div class="detail-upload-field__label">
                    <span class="req-star">*</span>赛事主视觉<span
                      class="detail-title-hint detail-title-hint--after-label"
                      >尺寸建议370*568，最大300KB，优先webp次选png</span
                    >
                  </div>
                  <div class="detail-upload-field__body">
                    <el-form-item
                      prop="visualUrl"
                      label=""
                      label-width="0px"
                      class="detail-upload-inner-form-item"
                    >
                      <div class="match-upload-block">
                        <div class="match-dynamic-upload-list">
                          <div class="match-dynamic-upload-bezel match-dynamic-upload-bezel--210">
                            <SUpload
                              v-if="imagesEditable"
                              v-model="form.visualUrl"
                              actionUrl="/adminapi/v1/basicTools/v650/file/upload?uploadImageType=11&fileType=1"
                              :headers="uploadAuthHeaders"
                              accept="image/*"
                              type="drag"
                              :size="300"
                              :show-file-list="false"
                            />
                            <div
                              v-else-if="form.visualUrl"
                              class="match-upload-preview-box match-upload-preview-box--view"
                              @click="previewImage(form.visualUrl)"
                            >
                              <img :src="form.visualUrl" alt="" />
                            </div>
                            <div v-else class="match-upload-empty-view">
                              暂无图片
                            </div>
                          </div>
                        </div>
                      </div>
                    </el-form-item>
                  </div>
                </div>
                <div class="detail-upload-field">
                  <div
                    class="detail-upload-field__label detail-upload-field__label--wrap"
                  >
                    <span class="req-star">*</span
                    >主色调背景（比赛规则、赛事状态、我的进度三个模块的背景图）<span
                      class="detail-title-hint detail-title-hint--after-label"
                      >尺寸建议370*588，最大300KB，优先webp次选png</span
                    >
                  </div>
                  <div class="detail-upload-field__body">
                    <el-form-item
                      prop="mainColorBgUrl"
                      label=""
                      label-width="0px"
                      class="detail-upload-inner-form-item"
                    >
                      <div class="match-upload-block">
                        <div class="match-dynamic-upload-list">
                          <div class="match-dynamic-upload-bezel match-dynamic-upload-bezel--210">
                            <SUpload
                              v-if="imagesEditable"
                              v-model="form.mainColorBgUrl"
                              actionUrl="/adminapi/v1/basicTools/v650/file/upload?uploadImageType=11&fileType=1"
                              :headers="uploadAuthHeaders"
                              accept="image/*"
                              type="drag"
                              :size="300"
                              :show-file-list="false"
                            />
                            <div
                              v-else-if="form.mainColorBgUrl"
                              class="match-upload-preview-box match-upload-preview-box--view"
                              @click="previewImage(form.mainColorBgUrl)"
                            >
                              <img :src="form.mainColorBgUrl" alt="" />
                            </div>
                            <div v-else class="match-upload-empty-view">
                              暂无图片
                            </div>
                          </div>
                        </div>
                      </div>
                    </el-form-item>
                  </div>
                </div>
                <div class="detail-upload-field">
                  <div
                    class="detail-upload-field__label detail-upload-field__label--wrap"
                  >
                    <span class="req-star">*</span
                    >赛事介绍（包括赛事导语、套餐介绍、奖品细节、赛事规则等）<span
                      class="detail-title-hint detail-title-hint--after-label"
                      >建议宽度：402px，jpg/png</span
                    >
                  </div>
                  <div class="detail-upload-field__body">
                    <el-form-item
                      prop="introUrl"
                      label=""
                      label-width="0px"
                      class="detail-upload-inner-form-item"
                    >
                      <div class="match-upload-block">
                        <div class="match-dynamic-upload-list">
                          <div
                            class="match-dynamic-upload-bezel match-dynamic-upload-bezel--multi"
                          >
                            <template v-if="imagesEditable">
                              <div class="match-upload-thumbs">
                                <div
                                  v-for="(url, idx) in introUrlList"
                                  :key="idx"
                                  class="match-upload-thumb match-upload-thumb--view"
                                  @click="previewImage(url)"
                                >
                                  <img :src="url" alt="" />
                                  <el-button
                                    type="text"
                                    class="match-upload-close"
                                    @click.stop="removeIntroImage(idx)"
                                  >
                                    <i class="el-icon-circle-cross"></i>
                                  </el-button>
                                </div>
                                <div
                                  class="match-upload-thumb"
                                  v-if="introUrlList.length < 10"
                                >
                                  <div
                                    v-if="matchImageUploading === 'introUrl'"
                                    class="match-upload-loading"
                                  >
                                    <i class="el-icon-loading"></i>
                                    <span>上传中…</span>
                                  </div>
                                  <el-upload
                                    v-else
                                    drag
                                    class="match-upload-dragger"
                                    action="#"
                                    :auto-upload="false"
                                    :show-file-list="false"
                                    :on-change="onIntroChange"
                                    accept="image/*"
                                  >
                                    <div style="margin-top: 25px">
                                      <i class="el-icon-upload"></i>
                                    </div>
                                  </el-upload>
                                </div>
                              </div>
                            </template>
                            <template v-else>
                              <div class="match-upload-thumbs">
                                <div
                                  v-for="(url, idx) in introUrlList"
                                  :key="idx"
                                  class="match-upload-thumb match-upload-thumb--view"
                                  @click="previewImage(url)"
                                >
                                  <img :src="url" alt="" />
                                </div>
                              </div>
                              <div
                                v-if="!introUrlList.length"
                                class="match-upload-empty-view"
                              >
                                暂无图片
                              </div>
                            </template>
                          </div>
                        </div>
                      </div>
                    </el-form-item>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="detail-section">
            <div class="detail-title-row detail-title-row--share">
              <span class="detail-title">分享站外配置</span>
            </div>
            <div class="detail-content">
              <div class="detail-stack">
                <div class="detail-upload-field">
                  <div class="detail-upload-field__label">
                    <span class="req-star">*</span><span>封面图</span>
                    <span
                      class="detail-title-hint detail-title-hint--after-label"
                      >尺寸建议50*50，最大50KB，优先SVG其次png</span
                    >
                  </div>
                  <div class="detail-upload-field__body">
                    <el-form-item
                      prop="shareCoverUrl"
                      label=""
                      label-width="0px"
                      class="detail-upload-inner-form-item"
                    >
                      <div class="match-upload-block">
                        <div class="match-dynamic-upload-list">
                          <div class="match-dynamic-upload-bezel match-dynamic-upload-bezel--210">
                            <SUpload
                              v-if="mode !== 'view'"
                              v-model="form.shareCoverUrl"
                              actionUrl="/adminapi/v1/basicTools/v650/file/upload?uploadImageType=11&fileType=1"
                              :headers="uploadAuthHeaders"
                              accept="image/*"
                              type="drag"
                              :size="50"
                              :show-file-list="false"
                            />
                            <div
                              v-else-if="form.shareCoverUrl"
                              class="match-upload-preview-box match-upload-preview-box--view"
                              @click="previewImage(form.shareCoverUrl)"
                            >
                              <img :src="form.shareCoverUrl" alt="" />
                            </div>
                            <div v-else class="match-upload-empty-view">
                              暂无图片
                            </div>
                          </div>
                        </div>
                      </div>
                    </el-form-item>
                  </div>
                </div>
                <el-form-item
                  prop="shareTitle"
                  label=""
                  label-width="0px"
                  class="detail-share-text-row"
                >
                  <div class="detail-share-field-row">
                    <span
                      class="detail-upload-field__label detail-share-field-row__label"
                      ><span class="req-star">*</span>标题</span
                    >
                    <el-input
                      v-model="form.shareTitle"
                      placeholder="不超过50字"
                      :maxlength="50"
                      show-word-limit
                      :disabled="formDisabled"
                      class="same-width-input detail-share-field-row__input"
                    ></el-input>
                  </div>
                </el-form-item>
                <el-form-item
                  label=""
                  label-width="0px"
                  class="detail-share-text-row"
                >
                  <div class="detail-share-field-row">
                    <span
                      class="detail-upload-field__label detail-share-field-row__label"
                      >描述（非必填）</span
                    >
                    <el-input
                      v-model="form.shareDesc"
                      placeholder="不超过20字"
                      :maxlength="20"
                      show-word-limit
                      :disabled="formDisabled"
                      class="same-width-input detail-share-field-row__input"
                    ></el-input>
                  </div>
                </el-form-item>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 发布 -->
      <div class="section-card">
        <div class="section-title">发布</div>
        <div class="section-body">
          <el-form-item
            label=""
            label-width="0px"
            prop="publishType"
            class="publish-type-form-item"
          >
            <el-radio-group
              v-model="form.publishType"
              class="publish-radio-group"
              :disabled="formDisabled"
            >
              <div class="publish-option">
                <el-radio :label="1">仅预览</el-radio>
                <span class="publish-desc"
                  >（生成H5链接，用于校对信息，APP端不显示）</span
                >
              </div>
              <div class="publish-option">
                <el-radio :label="2">正式发布</el-radio>
                <span class="publish-desc">APP端直接显示，所有人可见</span>
              </div>
            </el-radio-group>
          </el-form-item>
        </div>
      </div>
    </el-form>

    <!-- 底部按钮 -->
    <div class="footer-actions">
      <el-button @click="goBack" size="medium">{{
        mode === "view" ? "返回" : "取消"
      }}</el-button>
      <template v-if="imagesEditable">
        <el-button
          type="primary"
          @click="handleSubmit"
          size="medium"
          :loading="submitLoading"
          >{{ isEdit ? "保存修改" : "创建赛事" }}</el-button
        >
      </template>
    </div>

    <!-- 图片预览弹窗 -->
    <el-dialog
      title="图片预览"
      v-model="imagePreviewVisible"
      :close-on-click-modal="true"
      :modal-append-to-body="false"
      width="800px"
      center
    >
      <img :src="previewImageUrl" class="preview-image" />
    </el-dialog>

    <!-- 关联奖品弹窗 -->
    <prize-select-dialog
      :visible.sync="prizeDialogVisible"
      :existing-prizes="currentPackagePrizes"
      @confirm="onPrizeConfirm"
    ></prize-select-dialog>
  </div>
</template>

<script>
import PackageConfig from "./PackageConfig.vue";
import PrizeSelectDialog from "./PrizeSelectDialog.vue";
import SUpload from "../../common/SUpload.vue";
import { createDefaultForm } from "./mockData";

const LOG_TAG = "[赛事详情]";

export default {
  name: "matchDetail",
  components: {
    PackageConfig,
    PrizeSelectDialog,
    SUpload,
  },
  data() {
    const now = new Date();
    const nowStr = now.toISOString().slice(0, 19).replace("T", " ");
    return {
      mode: "create", // 'create' | 'edit' | 'view'
      nowStr: nowStr,
      submitLoading: false,
      // 关联奖品弹窗相关
      prizeDialogVisible: false,
      currentPackageIndex: -1,
      // 图片预览相关
      imagePreviewVisible: false,
      previewImageUrl: "",
      signTimePickerOptions: {
        disabledDate: (time) => {
          return time.getTime() < now.getTime() - 8.64e7;
        },
      },
      matchTimePickerOptions: {
        disabledDate: (time) => {
          if (this.form.signTime && this.form.signTime[0]) {
            return time.getTime() < new Date(this.form.signTime[0]).getTime();
          }
          return time.getTime() < now.getTime() - 8.64e7;
        },
      },
      /** 赛事类型下拉选项（当前仅嗨跑节） */
      matchTypeOptions: [{ label: "嗨跑节", value: 1 }],
      form: createDefaultForm(),
      /** 套餐校验错误提示（空字符串时隐藏） */
      packagesError: "",
    };
  },
  watch: {
    "form.signTime"(val) {
      console.log("[赛事详情][报名时间变化]", val);
    },
    "form.endTime"(val) {
      console.log("[赛事详情][比赛时间变化]", val);
    },
  },
  computed: {
    /** Element UI 1.x：整表 validate 使用空 trigger；validator 不写 trigger 时每次校验都会执行（数组 trigger 与 change 在部分版本下会漏检） */
    formRules() {
      return {
        matchType: [{ validator: this.validateMatchTypeRule }],
        title: [
          { required: true, message: "请输入赛事标题", trigger: "blur" },
          { min: 1, max: 30, message: "赛事标题不超过30个字", trigger: "blur" },
        ],
        signTime: [{ validator: this.validateSignTimeRangeRule }],
        endTime: [{ validator: this.validateMatchTimeRangeRule }],
        finishType: [{ validator: this.validateFinishTypeRule }],
        runTypes: [{ validator: this.validateRunTypesRule }],
        paceType: [{ validator: this.validatePaceRule }],
        groups: [{ validator: this.validateGroupsRule }],
        coverUrl: [{ validator: this.validateCoverUrlRule }],
        visualUrl: [{ validator: this.validateVisualUrlRule }],
        mainColorBgUrl: [{ validator: this.validateMainColorBgUrlRule }],
        introUrl: [{ validator: this.validateIntroUrlRule }],
        shareCoverUrl: [{ validator: this.validateShareCoverUrlRule }],
        shareTitle: [
          { required: true, message: "请填写分享标题", trigger: "blur" },
          { max: 50, message: "分享标题不超过50个字", trigger: "blur" },
        ],
        publishType: [{ validator: this.validatePublishTypeRule }],
      };
    },
    isEdit() {
      return this.mode === "edit" || this.mode === "editImage";
    },
    /** 仅图片可编辑模式（type=edit-1）：表单文本/配置只读，图片上传可用 */
    formDisabled() {
      return this.mode === "view" || this.mode === "editImage";
    },
    /** 图片是否可编辑：查看模式只读，其余（创建/编辑/仅图片编辑edit-1）均可编辑 */
    imagesEditable() {
      return this.mode !== "view";
    },
    /** 赛事介绍图：form.introUrl 为逗号分隔的多图字符串，拆成数组供列表展示 */
    introUrlList() {
      if (!this.form.introUrl) return [];
      return String(this.form.introUrl)
        .split(",")
        .map((s) => s.trim())
        .filter(Boolean);
    },
    pageTitle() {
      const titles = {
        create: "创建赛事",
        edit: "编辑赛事",
        editImage: "编辑赛事图片",
        view: "查看赛事",
      };
      return titles[this.mode] || "创建赛事";
    },
    /** 当前正在编辑的套餐已关联奖品列表，传给关联奖品弹窗做初始勾选 */
    currentPackagePrizes() {
      const pkg = this.form.packages[this.currentPackageIndex];
      return pkg && Array.isArray(pkg.prizeList) ? pkg.prizeList : [];
    },
    /** 图片走 v650 单文件上传 */
    matchImageV650UploadUrl() {
      return `${this.$util.domain}/adminapi/v1/basicTools/v650/file/upload?uploadImageType=11&fileType=1`;
    },
    uploadAuthHeaders() {
      return {
        Authorization: `Bearer ${localStorage.getItem("token") || ""}`,
      };
    },
  },
  mounted() {
    const { type, id } = this.$route.query;
    if (type === "edit-1" && id) {
      // 仅可编辑图片（套餐图、赛事封面图、赛事详情里的图），其余字段只读
      this.mode = "editImage";
      this.loadMatchData(id);
    } else if (type === "edit" && id) {
      this.mode = "edit";
      this.loadMatchData(id);
    } else if ((type === "view" || type === "detail") && id) {
      this.mode = "view";
      this.loadMatchData(id);
    } else if (type === "copy") {
      this.mode = "create";
      try {
        const raw = sessionStorage.getItem("copyMatchData");
        sessionStorage.removeItem("copyMatchData");
        if (raw) {
          const copyData = JSON.parse(raw);
          // competitionId 清空，确保走创建接口而非编辑接口
          copyData.competitionId = null;
          this.applyDetailToForm(copyData);
          console.log(LOG_TAG, "复制赛事数据已填充，基础信息需用户重新填写");
          this.$nextTick(() => {
            if (this.$refs.form) {
              this.$refs.form.clearValidate();
            }
          });
        }
      } catch (e) {
        console.warn(LOG_TAG, "读取复制赛事数据失败", e);
      }
    }
  },
  methods: {
    formatDatetime(val) {
      if (!val) return "";
      const pad = (n) => String(n).padStart(2, "0");
      let d;
      if (val instanceof Date) {
        d = val;
      } else if (typeof val === "string") {
        // 已经是 yyyy-MM-dd HH:mm:ss 格式，直接返回
        if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/.test(val)) return val;
        d = new Date(val);
      } else {
        return "";
      }
      if (isNaN(d.getTime())) return "";
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(
        d.getDate()
      )} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
    },
    validateMatchTypeRule(rule, value, callback) {
      if (value === undefined || value === null || value === "") {
        callback(new Error("请选择赛事类型"));
        return;
      }
      callback();
    },
    validatePublishTypeRule(rule, value, callback) {
      if (value !== 1 && value !== 2) {
        callback(new Error("请选择发布方式"));
        return;
      }
      callback();
    },
    validateFinishTypeRule(rule, value, callback) {
      const n =
        value !== undefined && value !== null && value !== ""
          ? Number(value)
          : NaN;
      if (!Number.isFinite(n) || (n !== 1 && n !== 2)) {
        callback(new Error("请选择比赛要求"));
        return;
      }
      callback();
    },
    validateSignTimeRangeRule(rule, value, callback) {
      if (
        !value ||
        !Array.isArray(value) ||
        value.length !== 2 ||
        !value[0] ||
        !value[1]
      ) {
        callback(new Error("请选择报名时间"));
      } else {
        callback();
      }
    },
    validateMatchTimeRangeRule(rule, value, callback) {
      if (
        !value ||
        !Array.isArray(value) ||
        value.length !== 2 ||
        !value[0] ||
        !value[1]
      ) {
        callback(new Error("请选择比赛时间"));
        return;
      }
      const signEnd = this.form.signTime && this.form.signTime[1];
      if (
        signEnd &&
        new Date(value[1]).getTime() < new Date(signEnd).getTime()
      ) {
        callback(new Error("比赛结束时间不能早于报名结束时间"));
        return;
      }
      callback();
    },
    /** 户外跑必选(1)；可叠加校园跑(2)；禁止仅校园跑 */
    validateRunTypesRule(rule, value, callback) {
      const arr = Array.isArray(value) ? value : [];
      if (!arr.includes(1)) {
        callback(new Error("须包含户外跑"));
        return;
      }
      if (arr.length === 1 && arr[0] === 2) {
        callback(new Error("不可单独只选校园跑"));
        return;
      }
      callback();
    },
    /** 同步跑步类型业务规则到 model（禁止仅校园跑；户外必选） */
    normalizeRunTypes(arr) {
      let next = Array.isArray(arr)
        ? [...new Set(arr)].sort((a, b) => a - b)
        : [];
      if (next.length === 1 && next[0] === 2) {
        return [1];
      }
      if (!next.includes(1)) next.push(1);
      return [...new Set(next)].sort((a, b) => a - b);
    },
    onRunTypesChange(val) {
      const normalized = this.normalizeRunTypes(val);
      if (JSON.stringify(normalized) !== JSON.stringify(this.form.runTypes)) {
        this.form.runTypes = normalized;
      }
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.validateField("runTypes");
        }
      });
    },
    validateCoverUrlRule(rule, value, callback) {
      if (!value || !String(value).trim()) {
        callback(new Error("请上传赛事封面图"));
        return;
      }
      callback();
    },
    validateVisualUrlRule(rule, value, callback) {
      if (!value || !String(value).trim()) {
        callback(new Error("请上传赛事主视觉"));
        return;
      }
      callback();
    },
    validateMainColorBgUrlRule(rule, value, callback) {
      if (!value || !String(value).trim()) {
        callback(new Error("请上传主色调背景"));
        return;
      }
      callback();
    },
    validateIntroUrlRule(rule, value, callback) {
      if (!value || !String(value).trim()) {
        callback(new Error("请上传赛事介绍图"));
        return;
      }
      callback();
    },
    validateShareCoverUrlRule(rule, value, callback) {
      if (!value || !String(value).trim()) {
        callback(new Error("请上传分享站外封面图"));
        return;
      }
      callback();
    },
    validatePaceRule(rule, value, callback) {
      if (this.form.paceType !== 1) {
        callback();
        return;
      }
      const f = this.form;
      const fields = [f.paceMin, f.paceMax, f.paceMinEnd, f.paceMaxEnd];
      if (fields.some((x) => x === undefined || x === null || x === "")) {
        callback(new Error("选择限制配速时，请填写完整配速区间"));
        return;
      }
      callback();
    },
    validateGroupsRule(rule, value, callback) {
      const msg = this.getGroupsValidationMessage();
      if (msg) {
        callback(new Error(msg));
        return;
      }
      callback();
    },
    getGroupsValidationMessage() {
      const groups = this.form.groups || [];
      if (!groups.length) {
        return "请至少保留一组参赛组别";
      }
      for (let i = 0; i < groups.length; i++) {
        const g = groups[i];
        const row = i + 1;
        if (g.type === 1) {
          if (g.distanceType === 0) {
            const d = g.distance;
            if (d === undefined || d === null || String(d).trim() === "") {
              return `参赛组别第${row}行：请填写公里数`;
            }
          }
        } else if (g.type === 2) {
          const d = g.distance;
          if (d === undefined || d === null || String(d).trim() === "") {
            return `参赛组别第${row}行：请填写消耗（千卡）`;
          }
          if (!/^\d+$/.test(String(d).trim())) {
            return `参赛组别第${row}行：消耗须为正整数（千卡）`;
          }
        }
      }
      return null;
    },
    /** 套餐至少 1 个；必填：图片、标题、价格类型/付费金额、限量类型、奖品及表格子项、奖品限量时的库存、实物奖品时的发货时限 */
    validatePackagesForSubmit() {
      const pkgs = this.form.packages || [];
      if (pkgs.length === 0) {
        return "请至少添加一个套餐";
      }
      const priceOk = /^\d+(\.\d{1,2})?$/;
      const prizeIsPhysical = (prize) => Number(prize && prize.prizeType) === 5;
      for (let i = 0; i < pkgs.length; i++) {
        const p = pkgs[i];
        const name =
          (p.packageTitle && String(p.packageTitle).trim()) ||
          `第${i + 1}个套餐`;
        if (!p.coverUrl || !String(p.coverUrl).trim()) {
          return `「${name}」请上传套餐图片`;
        }
        if (!p.packageTitle || !String(p.packageTitle).trim()) {
          return `第${i + 1}个套餐：请填写套餐标题`;
        }
        if (p.priceType !== 1 && p.priceType !== 2) {
          return `「${name}」请选择套餐价格（免费或付费）`;
        }
        if (p.priceType === 2) {
          const raw = String(p.price != null ? p.price : "").trim();
          if (!raw) {
            return `「${name}」请填写付费金额（元）`;
          }
          if (!priceOk.test(raw)) {
            return `「${name}」付费金额须为最多两位小数的正数（元）`;
          }
          const n = Number(raw);
          if (!Number.isFinite(n) || n <= 0) {
            return `「${name}」付费金额须大于 0（元）`;
          }
        }
        if (p.limitType !== 1 && p.limitType !== 2) {
          return `「${name}」请选择限量类型`;
        }
        if (!p.prizeList || !p.prizeList.length) {
          return `「${name}」请至少关联一个奖品`;
        }
        for (let j = 0; j < p.prizeList.length; j++) {
          const row = p.prizeList[j];
          const prizeLabel =
            row.prizeName ||
            `奖品ID ${row.prizeId != null ? row.prizeId : j + 1}`;
          if (row.signLimitType === 1) {
            const s = String(row.signLimit != null ? row.signLimit : "").trim();
            if (!s || !/^\d+$/.test(s) || parseInt(s, 10) <= 0) {
              return `「${name}」${prizeLabel}：报名限量为「限量」时请填写正整数`;
            }
          }
          if (row.activityLimitType === 1) {
            const a = String(
              row.activityLimit != null ? row.activityLimit : ""
            ).trim();
            if (!a) {
              return `「${name}」${prizeLabel}：活动限定为「是」时请填写标签名`;
            }
          }
        }
        if (p.limitType === 1) {
          if (p.stockType !== 0 && p.stockType !== 1) {
            return `「${name}」请选择套餐库存（不限量或限量）`;
          }
          if (p.stockType === 1) {
            const st = String(p.stock != null ? p.stock : "").trim();
            if (!st || !/^\d+$/.test(st) || parseInt(st, 10) <= 0) {
              return `「${name}」套餐库存为「限量」时请填写库存数量（正整数）`;
            }
          }
        }
        const needDelivery = (p.prizeList || []).some(prizeIsPhysical);
        if (needDelivery) {
          if (!p.deliveryDeadline || String(p.deliveryDeadline).trim() === "") {
            return `「${name}」包含实物奖品，请选择实物奖励发货时限`;
          }
        }
      }
      return null;
    },
    /** 日期区间选完后同步清除校验（Element UI 1.x 选完后仍以 blur 为准更稳妥） */
    onSignTimePickerChange() {
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.validateField("signTime");
          // 报名结束时间变化后，同步刷新比赛时间的跨字段校验
          if (this.form.endTime && this.form.endTime[1]) {
            this.$refs.form.validateField("endTime");
          }
        }
      });
    },
    onMatchTimePickerChange() {
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.validateField("endTime");
        }
      });
    },
    onGroupDistanceChange(group) {
      group.marathonType = "";
    },
    addGroup() {
      if (this.form.groups.length < 6) {
        this.form.groups.push({ type: 1, distanceType: 0, distance: "" });
      }
    },
    onGroupTypeChange(group) {
      if (group.type !== 1) {
        group.distanceType = 0;
        group.distance = "";
      }
    },
    onDistanceTypeChange(group) {
      if (group.distanceType === 1) {
        group.distance = "21.098";
      } else if (group.distanceType === 2) {
        group.distance = "42.195";
      } else {
        group.distance = "";
      }
    },
    /** 仅保留数字；至多一个小数点；小数位最多 2 位 */
    _sanitizeDistance(raw) {
      let str = String(raw != null ? raw : "").replace(/[^\d.]/g, "");
      const firstDot = str.indexOf(".");
      if (firstDot === -1) return str;
      const intPart = str.slice(0, firstDot).replace(/\D/g, "");
      let decPart = str
        .slice(firstDot + 1)
        .replace(/\./g, "")
        .replace(/\D/g, "");
      decPart = decPart.slice(0, 2);
      if (str.endsWith(".") && decPart === "") {
        return intPart === "" ? "" : `${intPart}.`;
      }
      if (intPart === "" && decPart !== "") return `0.${decPart}`;
      if (decPart === "") return intPart;
      return `${intPart}.${decPart}`;
    },
    onDistanceKeydown(e) {
      const key = e.key;
      if (
        e.ctrlKey ||
        e.metaKey ||
        [
          "Backspace",
          "Delete",
          "Tab",
          "Escape",
          "Enter",
          "ArrowLeft",
          "ArrowRight",
          "ArrowUp",
          "ArrowDown",
          "Home",
          "End",
        ].includes(key)
      )
        return;
      if (/^\d$/.test(key)) {
        const cur = e.target.value;
        const dotIdx = cur.indexOf(".");
        if (dotIdx !== -1) {
          const selStart = e.target.selectionStart;
          const selEnd = e.target.selectionEnd;
          const decPart = cur.slice(dotIdx + 1);
          const selectedDecLen = Math.max(
            0,
            Math.min(selEnd, cur.length) - Math.max(selStart, dotIdx + 1)
          );
          if (selStart > dotIdx && decPart.length - selectedDecLen >= 2) {
            e.preventDefault();
          }
        }
        return;
      }
      if (key === ".") {
        if (e.target.value.includes(".")) e.preventDefault();
        return;
      }
      e.preventDefault();
    },
    onDistancePaste(e, group) {
      const pasted = (e.clipboardData || window.clipboardData).getData("text");
      const cleaned = this._sanitizeDistance(pasted);
      group.distance = cleaned;
      this.$nextTick(() => {
        if (e.target) e.target.value = cleaned;
      });
    },
    onDistanceInput(val, group) {
      const raw =
        val && typeof val === "object" && val.target != null
          ? String(val.target.value)
          : String(val != null ? val : "");
      const cleaned = this._sanitizeDistance(raw);
      const prev = group.distance;
      group.distance = cleaned;
      if (prev === cleaned) {
        this.$nextTick(() => {
          const active = document.activeElement;
          if (active && active.tagName === "INPUT") active.value = cleaned;
        });
      }
    },
    onDistanceBlur(group) {
      let s = this._sanitizeDistance(group.distance || "");
      if (s.endsWith(".")) s = s.slice(0, -1);
      group.distance = s;
    },
    onDistanceCompositionEnd(e, group) {
      const cleaned = this._sanitizeDistance(e.target.value);
      group.distance = cleaned;
      this.$nextTick(() => {
        if (e.target) e.target.value = cleaned;
      });
    },
    /** 消耗值：仅正整数（千卡） */
    _sanitizeCalorie(raw) {
      return String(raw || "")
        .replace(/\D/g, "")
        .replace(/^0+(\d)/, "$1")
        .replace(/^0+$/, "");
    },
    onCalorieKeydown(e) {
      const key = e.key;
      const allow = [
        "Backspace",
        "Delete",
        "ArrowLeft",
        "ArrowRight",
        "Tab",
        "Home",
        "End",
      ];
      if (allow.includes(key)) return;
      if (e.ctrlKey || e.metaKey) return;
      if (/^\d$/.test(key)) {
        if (key === "0" && e.target.value.length === 0) {
          e.preventDefault();
          return;
        }
        return;
      }
      e.preventDefault();
    },
    onCaloriePaste(e, group) {
      const pasted = (e.clipboardData || window.clipboardData).getData("text");
      const cleaned = this._sanitizeCalorie(pasted);
      group.distance = cleaned;
      this.$nextTick(() => {
        if (e.target) e.target.value = cleaned;
      });
    },
    onCalorieInput(val, group) {
      const raw =
        val && typeof val === "object" && val.target != null
          ? String(val.target.value)
          : String(val != null ? val : "");
      const cleaned = this._sanitizeCalorie(raw);
      const prev = group.distance;
      group.distance = cleaned;
      if (prev === cleaned) {
        this.$nextTick(() => {
          const active = document.activeElement;
          if (active && active.tagName === "INPUT") active.value = cleaned;
        });
      }
    },
    onCalorieCompositionEnd(e, group) {
      const cleaned = this._sanitizeCalorie(e.target.value);
      group.distance = cleaned;
      this.$nextTick(() => {
        if (e.target) e.target.value = cleaned;
      });
    },
    removeGroup(index) {
      this.form.groups.splice(index, 1);
      this.$nextTick(() => {
        if (this.$refs.form) this.$refs.form.validateField("groups", () => {});
      });
    },
    /**
     * POST v650 上传图片，解析 data 为 URL 字符串（与 UploadItem / courseEdit.uploadFile 一致）
     */
    postV650MatchImage(file) {
      const fd = new FormData();
      fd.append("uploadFile", file);
      return this.$http({
        method: "POST",
        url: this.matchImageV650UploadUrl,
        body: fd,
        headers: this.uploadAuthHeaders,
      }).then((res) => {
        const body = res.body !== undefined ? res.body : res.data;
        const code = body && body.error;
        if (code !== 10000 && code !== 0) {
          console.warn(LOG_TAG, "v650 image upload fail", body);
          return Promise.reject(
            new Error((body && (body.message || body.msg)) || "上传失败")
          );
        }
        const raw = body.data;
        const url =
          typeof raw === "string"
            ? raw.trim()
            : raw && typeof raw.url === "string"
            ? raw.url.trim()
            : "";
        if (!url) {
          return Promise.reject(new Error("未返回图片地址"));
        }
        return url;
      });
    },
    onIntroChange(file) {
      this.appendMatchImage(file, "introUrl");
    },
    /** 赛事介绍图支持多张：上传后追加到逗号分隔的 introUrl 字符串 */
    appendMatchImage(file, urlKey) {
      if (!file || !file.raw) return;
      const current = this.form[urlKey]
        ? String(this.form[urlKey])
            .split(",")
            .map((s) => s.trim())
            .filter(Boolean)
        : [];
      if (current.length >= 10) {
        this.$util.errorMsg("赛事介绍图最多上传 10 张");
        return;
      }
      this.matchImageUploading = urlKey;
      this.postV650MatchImage(file.raw)
        .then((url) => {
          const list = this.form[urlKey]
            ? String(this.form[urlKey])
                .split(",")
                .map((s) => s.trim())
                .filter(Boolean)
            : [];
          list.push(url);
          this.form[urlKey] = list.join(",");
          const fileMap = {
            coverUrl: "coverFile",
            visualUrl: "visualFile",
            mainColorBgUrl: "mainColorBgFile",
            introUrl: "introFile",
            shareCoverUrl: "shareCoverFile",
          };
          const fk = fileMap[urlKey];
          if (fk) this.form[fk] = null;
          this.$nextTick(() => {
            if (this.$refs.form) {
              this.$refs.form.validateField(urlKey);
            }
          });
        })
        .catch((e) => {
          console.warn(LOG_TAG, "match image upload", e);
          this.$util.errorMsg(e.message || "上传失败");
        })
        .finally(() => {
          this.matchImageUploading = null;
        });
    },
    /** 删除赛事介绍图中的某一张（按索引） */
    removeIntroImage(index) {
      const list = this.form.introUrl
        ? String(this.form.introUrl)
            .split(",")
            .map((s) => s.trim())
            .filter(Boolean)
        : [];
      if (index < 0 || index >= list.length) return;
      list.splice(index, 1);
      this.form.introUrl = list.join(",");
      this.form.introFile = null;
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.validateField("introUrl");
        }
      });
    },
    onHeaderImgChange(file) {
      this.form.headerImgFile = file.raw;
      this.form.headerImgUrl = URL.createObjectURL(file.raw);
    },
    onIntroImgChange(file) {
      this.form.introImgFile = file.raw;
      this.form.guideImgUrl = URL.createObjectURL(file.raw);
    },
    onGuideImgChange(file) {
      this.form.guideImgFile = file.raw;
      this.form.guideImgUrl = URL.createObjectURL(file.raw);
    },
    onDetailImgChange(file) {
      this.form.detailImgFile = file.raw;
      this.form.detailImgUrl = URL.createObjectURL(file.raw);
    },
    onRuleImgChange(file) {
      this.form.ruleImgFile = file.raw;
      this.form.ruleImgUrl = URL.createObjectURL(file.raw);
    },
    addPackage() {
      if (this.form.packages.length >= 10) {
        return;
      }
      const newId =
        this.form.packages.length > 0
          ? Math.max(...this.form.packages.map((p) => p.id)) + 1
          : 1;
      this.form.packages.push({
        id: newId,
        packageTitle: "",
        coverUrl: "",
        coverFile: null,
        priceType: 1,
        price: "",
        limitType: 1,
        stockType: 0,
        stock: "",
        deliveryDeadline: "",
        prizeList: [],
      });
      this.packagesError = "";
    },
    removePackage(index) {
      this.form.packages.splice(index, 1);
    },
    onRelatePrize(packageIndex) {
      this.currentPackageIndex = packageIndex;
      this.prizeDialogVisible = true;
    },
    /** 关联奖品弹窗确认回调：根据 pendingMap 更新套餐奖品列表 */
    onPrizeConfirm({ pendingMap }) {
      const packageData = this.form.packages[this.currentPackageIndex];
      if (!packageData) return;

      const pendingIds = Object.keys(pendingMap).map(Number);
      const previousIds = (packageData.prizeList || []).map((p) => p.prizeId);

      const addedIds = pendingIds.filter((id) => !previousIds.includes(id));
      const removedIds = previousIds.filter((id) => !pendingIds.includes(id));

      addedIds.forEach((id) => {
        const prize = pendingMap[id];
        if (prize) {
          packageData.prizeList.push({
            prizeId: prize.prizeId,
            prizeName: prize.prizeName,
            prizeType: prize.prizeType || 0,
            signLimitType: 0,
            signLimit: "",
            activityLimitType: 0,
            activityLimit: "",
            isHide: 0,
          });
        }
      });

      removedIds.forEach((id) => {
        const index = packageData.prizeList.findIndex((p) => p.prizeId === id);
        if (index > -1) packageData.prizeList.splice(index, 1);
      });

      const messages = [];
      if (addedIds.length > 0)
        messages.push(`成功关联 ${addedIds.length} 个奖品`);
      if (removedIds.length > 0)
        messages.push(`取消关联 ${removedIds.length} 个奖品`);
      if (messages.length > 0) {
        this.$message.success(messages.join("，"));
      } else {
        this.$message.info("未进行任何操作");
      }
    },
    isApiSuccess(errorCode) {
      return errorCode === 10000;
    },
    /** 配速「分 + 秒」合成为秒/公里（与后台 paceMin/paceMax 单位一致） */
    pacePairToSeconds(minutes, seconds) {
      const m = Number(minutes) || 0;
      const s = Number(seconds) || 0;
      return Math.max(0, Math.round(m * 60 + s));
    },
    /** 后台秒/公里 → 界面「分 + 秒」 */
    splitPaceSeconds(totalSec) {
      const sec = Math.max(0, Math.round(Number(totalSec) || 0));
      return {
        min: Math.floor(sec / 60),
        sec: sec % 60,
      };
    },
    normalizePrizeId(prizeId) {
      if (prizeId == null || prizeId === "") return 0;
      const n = Number(prizeId);
      return Number.isFinite(n) ? n : 0;
    },
    /** 表单奖品类型 → AdminCompetition 约定的整数枚举 */
    mapPrizeTypeToApiCode(t) {
      if (typeof t === "number" && Number.isFinite(t)) return t;
      const map = {
        member: 1,
        physical: 5,
        coupon: 3,
        头像挂件: 1,
        主题: 2,
        电子证书: 3,
        电子奖牌: 4,
        实物奖品: 5,
      };
      return map[t] != null ? map[t] : 5;
    },
    mapApiPrizeTypeToForm(code) {
      const n = Number(code);
      return Number.isFinite(n) ? n : 5;
    },
    buildGroupListPayload() {
      const distanceLabelMap = { 0: "自定义", 1: "半马", 2: "全马" };
      return (this.form.groups || []).map((g) => ({
        groupId: g.groupId || 0,
        groupType: g.type,
        groupValue: String(g.distance != null ? g.distance : ""),
        groupLabel: g.type === 1 ? distanceLabelMap[g.distanceType] || "" : "",
      }));
    },
    buildPackageListPayload() {
      return (this.form.packages || []).map((pkg) => {
        const isLimit = pkg.limitType === 1 && pkg.stockType === 1 ? 1 : 0;
        const limitValue = isLimit ? parseInt(pkg.stock, 10) || 0 : 0;
        return {
          packageId: pkg.id || 0,
          packageImage: pkg.coverUrl || "",
          packageName: pkg.packageTitle || "",
          price: pkg.priceType === 2 ? Number(pkg.price) || 0 : 0,
          limitType: pkg.limitType,
          isLimit,
          limitValue,
          deliveryTimeFrame: pkg.deliveryDeadline || "",
          prizeItems: (pkg.prizeList || []).map((p) => {
            const item = {
              prizeId: this.normalizePrizeId(p.prizeId),
              prizeName: p.prizeName || "",
              prizeType: this.mapPrizeTypeToApiCode(p.prizeType),
              label:
                p.activityLimitType === 1 ? String(p.activityLimit || "") : "",
              isHide: p.isHide,
            };
            if (pkg.limitType === 2) {
              item.isLimit = p.signLimitType;
              item.quantity =
                p.signLimitType === 1 ? parseInt(p.signLimit, 10) || 0 : 0;
            }
            return item;
          }),
        };
      });
    },
    /** 组装创建/更新赛事请求体（配速已转为秒/公里） */
    buildCompetitionPayload() {
      const f = this.form;
      const matchTypeLabel =
        (this.matchTypeOptions.find((o) => o.value === f.matchType) || {})
          .label || "嗨跑节";

      let paceMinSec = 0;
      let paceMaxSec = 0;
      if (f.paceType === 1) {
        // 横杠左边 → paceMin；横杠右边 → paceMax
        paceMinSec = this.pacePairToSeconds(f.paceMin, f.paceMax);
        paceMaxSec = this.pacePairToSeconds(f.paceMinEnd, f.paceMaxEnd);
      }

      const payload = {
        title: f.title || "",
        type: matchTypeLabel,
        coverImage: f.coverUrl || "",
        headerImage: f.visualUrl || "",
        mainColorBgImage: f.mainColorBgUrl || "",
        introduction: f.introUrl || "",
        packageIntroUrl: f.detailImgUrl || "",
        prizeDetailUrl: f.guideImgUrl || "",
        ruleUrl: f.ruleImgUrl || "",
        shareCoverImage: f.shareCoverUrl || "",
        shareTitle: f.shareTitle || "",
        description: f.shareDesc || "",
        registrationStartTime:
          f.signTime && f.signTime[0] ? this.formatDatetime(f.signTime[0]) : "",
        registrationEndTime:
          f.signTime && f.signTime[1] ? this.formatDatetime(f.signTime[1]) : "",
        startTime:
          f.endTime && f.endTime[0] ? this.formatDatetime(f.endTime[0]) : "",
        endTime:
          f.endTime && f.endTime[1] ? this.formatDatetime(f.endTime[1]) : "",
        completionType: f.finishType,
        paceLimitEnabled: f.paceType === 1 ? 1 : 0,
        paceMin: f.paceType === 1 ? paceMinSec : 0,
        paceMax: f.paceType === 1 ? paceMaxSec : 0,
        runTypeList: (f.runTypes || []).map(String),
        groupList: this.buildGroupListPayload(),
        packageList: this.buildPackageListPayload(),
        publishType: f.publishType === 2 ? 0 : 1,
      };

      if (this.isEdit && f.competitionId != null) {
        payload.competitionId = f.competitionId;
      }
      console.log(
        "[赛事详情][提交时间] registrationStartTime:",
        payload.registrationStartTime
      );
      console.log(
        "[赛事详情][提交时间] registrationEndTime:",
        payload.registrationEndTime
      );
      console.log("[赛事详情][提交时间] startTime:", payload.startTime);
      console.log("[赛事详情][提交时间] endTime:", payload.endTime);
      return payload;
    },
    applyDetailToForm(data) {
      if (!data) return;
      const f = this.form;
      f.competitionId = data.competitionId != null ? data.competitionId : null;
      f.title = data.title || "";
      const typeOpt = this.matchTypeOptions.find((o) => o.label === data.type);
      f.matchType = typeOpt != null ? Number(typeOpt.value) : 1;
      f.signTime =
        data.registrationStartTime && data.registrationEndTime
          ? [
              this.formatDatetime(data.registrationStartTime),
              this.formatDatetime(data.registrationEndTime),
            ]
          : [];
      f.endTime =
        data.startTime && data.endTime
          ? [
              this.formatDatetime(data.startTime),
              this.formatDatetime(data.endTime),
            ]
          : [];
      console.log(
        "[赛事详情][回显时间] 报名原始值:",
        data.registrationStartTime,
        data.registrationEndTime
      );
      console.log("[赛事详情][回显时间] 报名转换后:", f.signTime);
      console.log(
        "[赛事详情][回显时间] 比赛原始值:",
        data.startTime,
        data.endTime
      );
      console.log("[赛事详情][回显时间] 比赛转换后:", f.endTime);
      const ct = data.completionType;
      if (ct !== undefined && ct !== null && ct !== "") {
        const n = Number(ct);
        f.finishType = n === 1 || n === 2 ? n : undefined;
      } else {
        f.finishType = undefined;
      }
      {
        let rt = (data.runTypeList || [])
          .map((x) => Number(x))
          .filter((n) => !Number.isNaN(n));
        rt = this.normalizeRunTypes(rt);
        f.runTypes = rt.length ? rt : [1];
      }

      f.groups =
        data.groupList && data.groupList.length
          ? data.groupList.map((g) => ({
              groupId: g.groupId,
              type: g.groupType,
              distanceType: 0,
              distance: g.groupValue != null ? String(g.groupValue) : "",
            }))
          : [{ type: 1, distanceType: 0, distance: "" }];

      f.paceType = data.paceLimitEnabled === 1 ? 1 : 0;
      if (f.paceType === 1) {
        // 横杠左边 → paceMin；横杠右边 → paceMax
        const left = this.splitPaceSeconds(Number(data.paceMin) || 0);
        const right = this.splitPaceSeconds(Number(data.paceMax) || 0);
        f.paceMin = left.min;
        f.paceMax = left.sec;
        f.paceMinEnd = right.min;
        f.paceMaxEnd = right.sec;
      }

      f.coverUrl = data.coverImage || "";
      f.visualUrl = data.headerImage || "";
      f.mainColorBgUrl = data.mainColorBgImage || "";
      f.introUrl = data.introduction || "";
      f.detailImgUrl = data.packageIntroUrl || "";
      f.guideImgUrl = data.prizeDetailUrl || "";
      f.ruleImgUrl = data.ruleUrl || "";
      f.shareCoverUrl = data.shareCoverImage || "";
      f.shareTitle = data.shareTitle || "";
      f.shareDesc = data.description || "";
      f.publishType = data.publishType === 0 ? 2 : 1;

      f.packages = (data.packageList || []).map((p, idx) => ({
        id: p.packageId != null ? p.packageId : idx + 1,
        coverUrl: p.packageImage || "",
        coverFile: null,
        packageTitle: p.packageName || "",
        priceType: p.price > 0 ? 2 : 1,
        price: String(p.price != null ? p.price : ""),
        limitType: p.limitType != null ? p.limitType : 1,
        stockType: p.isLimit ? 1 : 0,
        stock: String(p.limitValue != null ? p.limitValue : ""),
        deliveryDeadline: p.deliveryTimeFrame || "",
        prizeList: (p.prizeItems || []).map((pi) => ({
          ...pi,
          prizeId: pi.prizeId,
          prizeName: pi.prizeName || "",
          prizeType: this.mapApiPrizeTypeToForm(pi.prizeType),
          signLimitType: pi.isLimit != null ? pi.isLimit : 0,
          signLimit:
            pi.quantity != null && pi.quantity !== ""
              ? String(pi.quantity)
              : "",
          activityLimitType: pi.label ? 1 : 0,
          activityLimit: pi.label || "",
        })),
      }));
    },
    loadMatchData(id) {
      this.$http({
        url: this.$util.domain + "/adminapi/competition/detail",
        method: "POST",
        body: JSON.stringify({ id: Number(id) }),
      })
        .then((res) => {
          const body = res.body || {};
          if (!this.isApiSuccess(body.error)) {
            console.warn(LOG_TAG, "detail fail", body);
            this.$util.errorMsg(body.message || body.msg || "加载赛事失败");
            return;
          }
          this.applyDetailToForm(body.data || {});
          this.$nextTick(() => {
            if (this.$refs.form) {
              this.$refs.form.clearValidate();
            }
          });
        })
        .catch((err) => {
          console.warn(LOG_TAG, "detail error", err);
          this.$util.errorMsg("网络异常，请稍后重试");
        });
    },
    handleSubmit() {
      const _fmt = (v) => this.formatDatetime(v);
      console.log(
        "[赛事详情][点击提交-时间字段] 原始值:",
        JSON.stringify({
          signTime: this.form.signTime,
          endTime: this.form.endTime,
        })
      );
      console.log(
        "[赛事详情][点击提交-时间字段] 转换后:",
        JSON.stringify({
          registrationStartTime: _fmt(
            this.form.signTime && this.form.signTime[0]
          ),
          registrationEndTime: _fmt(
            this.form.signTime && this.form.signTime[1]
          ),
          startTime: _fmt(this.form.endTime && this.form.endTime[0]),
          endTime: _fmt(this.form.endTime && this.form.endTime[1]),
        })
      );
      if (this.mode === "view") return;

      // edit-1（type=edit-1）：仅可编辑图片，进行中编辑赛事图片，走专用 online/update 接口
      if (this.mode === "editImage") {
        this.submitOnlineUpdate();
        return;
      }

      if (this.isEdit && this.form.competitionId == null) {
        this.$message.error("缺少赛事ID，无法保存");
        return;
      }
      if (!this.$refs.form) {
        this.$message.warning("表单未就绪，请稍后重试");
        return;
      }

      // 套餐为空时先标红提示，再继续走 form 校验（两者独立，不互相阻断）
      if ((this.form.packages || []).length === 0) {
        this.packagesError = "请至少添加一个套餐";
        this.$nextTick(() => {
          const el = this.$refs.packageSection;
          if (el) el.scrollIntoView({ behavior: "smooth", block: "center" });
        });
      } else {
        this.packagesError = "";
      }

      if (!this.introUrlList.length) {
        return this.$message.error("缺少赛事介绍图片");
      }

      this.$refs.form.validate((valid) => {
        if (!valid) {
          this.$message.warning("请完善必填项后再提交");
          return;
        }
        const pkgErr = this.validatePackagesForSubmit();
        if (pkgErr) {
          this.$message.warning(pkgErr);
          return;
        }
        if (this.submitLoading) return;

        const url = this.isEdit
          ? this.$util.domain + "/adminapi/competition/update"
          : this.$util.domain + "/adminapi/competition/create";
        const payload = this.buildCompetitionPayload();
        console.log(
          "[赛事详情][最终提交payload]",
          JSON.stringify({
            registrationStartTime: payload.registrationStartTime,
            registrationEndTime: payload.registrationEndTime,
            startTime: payload.startTime,
            endTime: payload.endTime,
          })
        );

        this.submitLoading = true;
        this.$http({
          url,
          method: "POST",
          body: JSON.stringify(payload),
        })
          .then((res) => {
            const body = res.body || {};
            if (!this.isApiSuccess(body.error)) {
              console.warn(LOG_TAG, "submit fail", body);
              this.$util.errorMsg(body.message || body.msg || "保存失败");
              return;
            }
            this.$message.success(this.isEdit ? "保存成功" : "创建成功");
            this.$router.push({ path: "/yunying/onlineMatch/matchManage" });
          })
          .catch((err) => {
            console.warn(LOG_TAG, "submit error", err);
            this.$util.errorMsg("网络异常，请稍后重试");
          })
          .finally(() => {
            this.submitLoading = false;
          });
      });
    },
    // edit-1 专用：进行中编辑赛事图片，调用 online/update，仅提交图片相关字段
    submitOnlineUpdate() {
      if (this.submitLoading) return;
      if (this.form.competitionId == null) {
        this.$message.error("缺少赛事ID，无法保存");
        return;
      }
      if (!this.introUrlList.length) {
        return this.$message.error("缺少赛事介绍图片");
      }
      const payload = this.buildOnlineUpdatePayload();
      this.submitLoading = true;
      this.$http({
        url: this.$util.domain + "/adminapi/competition/online/update",
        method: "POST",
        body: JSON.stringify(payload),
      })
        .then((res) => {
          const body = res.body || {};
          if (!this.isApiSuccess(body.error)) {
            this.$util.errorMsg(body.message || body.msg || "保存失败");
            return;
          }
          this.$message.success("保存成功");
          this.$router.push({ path: "/yunying/onlineMatch/matchManage" });
        })
        .catch(() => {
          this.$util.errorMsg("网络异常，请稍后重试");
        })
        .finally(() => {
          this.submitLoading = false;
        });
    },
    // 仅取 online/update 接口声明的字段（与 AdminCompetitionOnlineUpdateReq 对齐）
    buildOnlineUpdatePayload() {
      const f = this.form;
      return {
        competitionId: f.competitionId,
        coverImage: f.coverUrl || "",
        headerImage: f.visualUrl || "",
        mainColorBgImage: f.mainColorBgUrl || "",
        introduction: f.introUrl || "",
        shareCoverImage: f.shareCoverUrl || "",
        shareTitle: f.shareTitle || "",
        description: f.shareDesc || "",
        // 套餐配置列表：online/update 的 packageConfigList 项仅需 packageId/packageImage/packageName
        packageConfigList: (f.packages || []).map((pkg) => ({
          packageId: pkg.id || 0,
          packageImage: pkg.coverUrl || "",
          packageName: pkg.packageTitle || "",
        })),
      };
    },
    handleCopy() {
      this.mode = "create";
      this.form.competitionId = null;
      this.$message.success("已复制赛事，可修改后重新创建");
    },
    goBack() {
      const from = this.$route.query.from;
      if (from === "signUpManage") {
        this.$router.push({
          path: "/yunying/onlineMatch/signUpManage",
          query: { tab: "signup" },
        });
      } else {
        this.$router.push({ path: "/yunying/onlineMatch/matchManage" });
      }
    },
    previewImage(url) {
      this.previewImageUrl = url;
      this.imagePreviewVisible = true;
    },
  },
};
</script>

<style scoped>
.match-detail {
  padding: 20px;
  padding-bottom: 80px;
}
.same-width-input {
  width: 520px;
}
/* 自定义必填红星（与自定义 validator 配套，避免无星） */
.req-star {
  color: #ff4949;
  margin-right: 4px;
}
.page-header {
  display: flex;
  flex-wrap: nowrap;
  align-items: stretch;
  justify-content: space-between;
  height: 56px;
  margin-bottom: 20px;
  padding: 0 16px;
  background-color: #f5f7fa;
  box-sizing: border-box;
}
.page-header__title {
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 18px;
  font-weight: bold;
  line-height: 56px;
  height: 56px;
  overflow: hidden;
}
.section-card {
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  margin-bottom: 20px;
  overflow: hidden;
}
.section-title {
  background: #f5f7fa;
  padding: 12px 20px;
  font-size: 15px;
  font-weight: bold;
  color: #303133;
  border-bottom: 1px solid #e4e7ed;
  display: flex;
  align-items: center;
}
.section-body {
  padding: 20px 20px 10px;
  display: block;
}

/* 套餐配置必填错误提示 */
.packages-error-tip {
  padding: 6px 20px 6px 20px;
  color: #f56c6c;
  font-size: 12px;
  line-height: 1.6;
  background: #fff1f0;
  border-bottom: 1px solid #ffd6d6;
}

/* 套餐列表 */
.package-list {
  padding: 20px;
}
.package-item {
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  margin-bottom: 16px;
  overflow: hidden;
}
.package-header {
  background: #f5f7fa;
  padding: 10px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #e4e7ed;
}
.package-index {
  font-size: 14px;
  font-weight: bold;
  color: #303133;
}

.form-tip {
  font-size: 12px;
  color: #909399;
  line-height: 1.6;
  margin-top: 4px;
}

.detail-upload-inner-form-item {
  margin-bottom: 0;
}

/* 参赛组别 */
.group-list {
  width: 100%;
}
.group-item {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

/* 配速限制 */
.pace-radio-group {
  line-height: 40px;
}
.pace-limit-row {
  display: flex;
  align-items: center;
  margin-top: 10px;
  flex-wrap: wrap;
}
.pace-sep {
  margin: 0 6px;
  color: #606266;
  white-space: nowrap;
}

/* 赛事图片：v650 自定义上传；布局对齐「新增动态」DynamicDetail.image-list + image-bezel(150) + UploadItem 预览 180px */
.match-upload-block {
  width: 100%;
}
.match-dynamic-upload-list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  overflow: auto;
}
/* 与 theme-default 拖拽区默认宽度一致（360），避免缩成 150 与全局 dragger 样式打架；小屏由 max-width 约束 */
.match-dynamic-upload-bezel {
  width: 360px;
  max-width: 100%;
  box-sizing: border-box;
}
/* 封面图：不占 120px 标签列，与下方「赛事详情」选图区左缘对齐 */
.match-cover-form-item >>> .el-form-item__content {
  margin-left: 0 !important;
}
.match-upload-dragger >>> .el-upload {
  width: 100%;
}
/* theme-default 给 .el-upload-dragger 360×180 + 图标 67px 与 margin 40px，缩到 150px 宽时会撑破；此处强制覆盖 */
.match-upload-dragger >>> .el-upload-dragger {
  width: 100% !important;
  height: 180px !important;
  min-height: 180px !important;
  max-width: 100%;
  display: flex !important;
  flex-direction: column;
  align-items: center !important;
  justify-content: center !important;
  padding: 10px 6px !important;
  box-sizing: border-box !important;
}
.match-upload-dragger >>> .el-upload-dragger > div {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  box-sizing: border-box;
}
.match-upload-dragger >>> .el-upload-dragger .el-icon-upload {
  font-size: 32px !important;
  line-height: 1 !important;
  margin: 0 0 8px !important;
  color: #c0c4cc !important;
}
.match-upload-dragger >>> .el-upload-dragger .el-dragger__text {
  font-size: 12px !important;
  color: #606266 !important;
  line-height: 1.35 !important;
  text-align: center;
  padding: 0 4px !important;
}
.match-upload-dragger >>> .el-upload-dragger .el-dragger__text em {
  color: #409eff !important;
  font-style: normal;
}

/* 与 UploadItem .img-wrap 一致 */
.match-upload-preview-box {
  position: relative;
  width: 100%;
  height: 180px;
  line-height: 180px;
  border: 1px solid #c0ccda;
  border-radius: 4px;
  text-align: center;
  background: #fafafa;
  overflow: hidden;
  box-sizing: border-box;
}
.match-upload-preview-box img {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.match-upload-preview-box--view {
  cursor: pointer;
}
.match-upload-close {
  position: absolute;
  top: 0;
  right: 0;
  padding: 0;
  z-index: 1;
}
.match-upload-loading {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: #409eff;
  font-size: 14px;
  box-sizing: border-box;
}
.match-upload-empty-view {
  width: 100%;
  height: 180px;
  line-height: 180px;
  text-align: center;
  color: #909399;
  font-size: 13px;
  border: 1px dashed #e4e7ed;
  border-radius: 4px;
  background: #fafafa;
  box-sizing: border-box;
}
/* 赛事介绍：多图上传（缩略图网格 + 大上传区） */
.match-dynamic-upload-bezel--multi {
  width: 100%;
  max-width: 100%;
}
.match-upload-limit-tip {
  width: 100%;
  height: 120px;
  line-height: 120px;
  text-align: center;
  color: #909399;
  font-size: 13px;
  border: 1px dashed #e4e7ed;
  border-radius: 4px;
  background: #fafafa;
  box-sizing: border-box;
}
.match-upload-thumbs {
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 10px;
}
.match-upload-thumb {
  position: relative;
  width: 360px;
  height: 202px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  background: #fafafa;
}
.match-upload-thumb img {
  max-width: 100%;
  max-height: 100%;
}
.match-upload-thumb--view {
  cursor: pointer;
}
.match-upload-thumb .match-upload-close {
  top: 2px;
  right: 2px;
  color: #f56c6c;
  background: rgba(255, 255, 255, 0.85);
  border-radius: 50%;
  line-height: 1;
}

/* 套餐配置 */
.inline-form-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.price-unit {
  margin-left: 6px;
  color: #606266;
}
.cell-inline {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: nowrap;
}

/* 发布：无左侧「发布方式」标签，避免继承表单 label-width 留白 */
.publish-type-form-item >>> .el-form-item__content {
  margin-left: 0 !important;
}
.publish-radio-group {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.publish-option {
  display: flex;
  margin-bottom: 16px;
}
.publish-desc {
  font-size: 12px;
  color: #909399;
  line-height: 1.6;
  margin-left: 4px;
}

/* 底部按钮 */
.footer-actions {
  text-align: center;
  padding: 20px 0;
  margin-top: 10px;
}
.footer-actions .el-button {
  min-width: 120px;
}

/* 关联奖品弹窗 */

/* 查看模式图片样式 */
.cursor-pointer {
  cursor: pointer;
}
.cursor-pointer:hover {
  opacity: 0.8;
}
/* 图片预览弹窗样式 */
.preview-image {
  max-width: 100%;
  max-height: 600px;
  display: block;
  margin: 0 auto;
  object-fit: contain;
}

/* 赛事封面/详情/分享 — 大标题顶左；子块缩进 1.5em；上传与标题/描述均为标签在上、控件在下 */
.detail-section {
  margin-top: 18px;
}
.detail-section:first-child {
  margin-top: 0;
}
.detail-title-row {
  display: flex;
  align-items: baseline;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 10px;
}
.detail-title-row--share .detail-title {
  font-weight: bold;
}
.detail-title {
  font-size: 14px;
  font-weight: bold;
  color: #000000;
}
.detail-title-hint {
  font-size: 12px;
  color: #f56c6c;
  font-weight: normal;
}
.detail-title-hint--after-label {
  margin-left: 6px;
}
.detail-content {
  padding-left: 1.5em;
  box-sizing: border-box;
}
/* detail-stack：上传与分享文案均为手写上下结构；带校验的 el-form-item 去掉左侧 label 占位 */
.detail-stack > .detail-upload-field {
  margin-bottom: 16px;
}
.detail-stack > .el-form-item {
  margin-bottom: 16px;
}
.detail-stack >>> .el-form-item__content {
  margin-left: 0 !important;
  clear: both;
}
.detail-stack >>> .el-form-item__label {
  width: 0 !important;
  padding: 0 !important;
  overflow: hidden;
}
.detail-upload-field {
  width: 100%;
}
.detail-upload-field__label {
  font-size: 14px;
  color: #606266;
  line-height: 22px;
  padding-bottom: 8px;
}
.detail-upload-field__label--wrap {
  white-space: normal;
  line-height: 1.45;
}
.detail-upload-field__body .form-tip {
  margin-top: 4px;
}

/* 分享站：标题、描述 — 与「封面图」同款左标签 + 同一行输入框（左缘与封面图标题对齐） */
.detail-share-field-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  width: 100%;
  max-width: 640px;
}
.detail-share-field-row__label {
  padding-bottom: 0 !important;
  line-height: 40px !important;
  margin-right: 12px;
  flex-shrink: 0;
}
.detail-share-field-row__input {
  flex: 1;
  min-width: 220px;
}
.detail-share-field-row .same-width-input.detail-share-field-row__input {
  width: 100%;
  max-width: 520px;
}
.detail-stack >>> .detail-share-text-row.el-form-item .el-form-item__content {
  margin-left: 0 !important;
}

/* SUpload 宽度扩展为 210px */
.match-dynamic-upload-bezel--210 >>> .s-upload-preview__item {
  width: 210px;
  height: 210px;
}
</style>

<style>
.el-upload-dragger {
  background: transparent !important;
  border: none;
}
</style>



// WEBPACK FOOTER //
// matchDetail.vue?fe4a58ae